import { combineReducers } from 'redux';
import birthdate from './birthdate/store/birthdate.reducer';
import birthdateV2 from './birthdateV2/store/birthdate.reducer';
import gender from './gender/store/gender.reducer';
import location from './location/store/location.reducer';
import locationV2 from './locationV2/store/location.reducer';
import justProvince from './justProvince/store/justProvince.reducer';
import justLocaly from './justLocaly/store/location.reducer';
import nameReducer from './name/store/name.reducer';
import nameV2Reducer from './nameV2/store/name.reducer';
import fullNameV2Reducer from './fullNameV2/store/fullName.reducer';
import fullNameReducer from './fullName/store/fullName.reducer';
import socialNameReducer from './socialName/store/socialName.reducer';
import legalId from './legalId/store/legalId.reducer';
import legalIdV2 from './legalIdV2/store/legalId.reducer';
import personByLegalId from './personByLegalId/store/personByLegalId.reducer';
import mainDriverLegalId from './mainDriverLegalId/store/mainDriverLegalId.reducer';
import maritalStatus from './maritalStatus/store/maritalStatus.reducer';

const personReducer = combineReducers({
  name: nameReducer,
  nameV2: nameV2Reducer,
  namecompany: nameReducer,
  fullName: fullNameReducer,
  fullNameV2: fullNameV2Reducer,
  socialName: socialNameReducer,
  birthdate,
  birthdateV2,
  justLocaly,
  legalId,
  legalIdV2,
  personByLegalId,
  mainDriverLegalId,
  location,
  locationV2,
  justProvince,
  gender,
  maritalStatus,
});

export default personReducer;
